export enum FeaturePermissions {
  CanWriteEstimatedCompletionDate = 'Write',
  CanWriteActualCompletionDate = 'Write',
  UpdateClosingDate = 'UpdateClosingDate',
  UpdateEstimatedClosingDate = 'UpdateEstimatedClosingDate'
}
